import { taskTrackerApi } from '../api/taskTracker.api'
import {
  TaskTrackerBoardCard,
  TaskTrackerTaskStickerValue,
} from '../store/taskTracker.types'
import { isTaskTrackerSystemDatetimeStickerFieldType } from './taskTrackerBoard.stickerFilters.utils'
import { normalizeTaskDeadline } from './taskTrackerTaskInfo.utils'

export const normalizeStickerValueForApi = (
  value: string | null | undefined,
): string | null => {
  if (value == null) return null
  const trimmed = value.trim()
  return trimmed || null
}

export const getTaskTrackerStickerRawValue = (
  task: Pick<TaskTrackerBoardCard, 'deadline' | 'stickers'>,
  sticker: Pick<TaskTrackerTaskStickerValue, 'fieldSettingId' | 'fieldType' | 'value'>,
) => {
  if (sticker.fieldType === 'deadline') {
    return normalizeTaskDeadline(task.deadline) ?? sticker.value
  }

  return sticker.value
}

export const getTaskTrackerStickerNormalizedValue = (
  task: Pick<TaskTrackerBoardCard, 'deadline' | 'stickers'>,
  fieldSettingId: number,
  fieldType: string,
  fallbackValue?: string | null,
): string | null => {
  if (fieldType === 'deadline') {
    return normalizeTaskDeadline(task.deadline)
  }

  const sticker = task.stickers.find(
    (item) => item.fieldSettingId === fieldSettingId,
  )

  return normalizeStickerValueForApi(sticker?.value ?? fallbackValue ?? null)
}

export const normalizeTaskTrackerStickerValueForPersist = (
  fieldType: string,
  value: string | null | undefined,
): string | null =>
  isTaskTrackerSystemDatetimeStickerFieldType(fieldType)
    ? null
    : fieldType === 'deadline'
    ? normalizeTaskDeadline(value)
    : normalizeStickerValueForApi(value)

export const persistTaskTrackerStickerValue = async (
  taskId: number,
  params: {
    fieldSettingId: number
    fieldType: string
    value: string | null | undefined
  },
): Promise<TaskTrackerBoardCard> => {
  if (isTaskTrackerSystemDatetimeStickerFieldType(params.fieldType)) {
    throw new Error('Значение этого системного стикера заполняется автоматически')
  }

  const normalizedValue = normalizeTaskTrackerStickerValueForPersist(
    params.fieldType,
    params.value,
  )

  if (params.fieldType === 'deadline') {
    return taskTrackerApi.updateTask(taskId, { deadline: normalizedValue })
  }

  return taskTrackerApi.setTaskStickerValue(taskId, {
    fieldSettingId: params.fieldSettingId,
    value: normalizedValue,
  })
}
